import React from "react";

export const Spinner = ({ width = 30, height = 30, innerSize = 15, color = "white" }) => {
  return (
    <div
      className="lds-ring"
      style={{
        "--width": width + 'px',
        "--height": height + 'px',
        "--innerSize": innerSize + 'px',
        "--color": color,
      }}
    >
      <div></div>
      <div></div>
      <div></div>
      <div></div>
    </div>
  );
};
